import { call, put } from 'redux-saga/effects'
import firebase from '../config/firebase'
import { MenuTypes } from '../reducers/menuReducer'

export function* fetchMenus() {
  try {
    const menuRef = firebase
      .database()
      .ref('menus')
      .orderByChild('order')
    const response = yield call([menuRef, menuRef.once], 'value')
    if (response.val() !== null) {
      let menus = {}
      response.forEach(menu => {
        menus[menu.key] = menu.val()
      })
      yield put({ type: MenuTypes.FETCH_MENUS_CONNECTED, data: menus })
    }
  } catch (error) {
    yield put({ type: MenuTypes.FETCH_MENUS_ERROR, error: error })
  }
}

export function* fetchSelectedCategories() {
  try {
    const categories = firebase
      .database()
      .ref('selected_categories')
      .orderByChild('order')
    const response = yield call([categories, categories.once], 'value')

    if (response.val() !== null) {
      let newObj = {}

      response.forEach(res => {
        newObj[res.key] = res.val()
      })

      yield put({ type: MenuTypes.FETCH_SELECTED_CATEGORIES_CONNECTED, data: newObj })
    } else {
      yield put({ type: MenuTypes.FETCH_SELECTED_CATEGORIES_CONNECTED, data: {} })
    }
  } catch (error) {
    yield put({ type: MenuTypes.FETCH_SELECTED_CATEGORIES_ERROR, error: error })
  }
}



// WEBPACK FOOTER //
// ./src/sagas/menuSaga.js